import React from 'react';
import PropTypes from 'prop-types';
import { VictoryLabel, VictoryVoronoiContainer, VictoryTooltip } from 'victory';
import { alpha } from '@material-ui/core';
import { themeWithoutDir as theme } from '~/modules/App/withRootTheme';

const TOOLTIP_CORNER_RADIUS = 5;
const TOOLTIP_POINTER_LENGTH = 0;
const TOOLTIP_CENTER_OFFSET = { y: 50 };

const baseTextStyle = {
  fill: theme.palette.text.white,
  fontSize: `${parseFloat(theme.typography.caption.fontSize) *
    theme.spacing(2)}px`,
  fontFamily: theme.typography.fontFamily,
  fontWeight: 400,
  textAnchor: 'start'
};

const tooltipStyles = {
  text: {
    base: baseTextStyle,
    bold: { ...baseTextStyle, fontWeight: 700 }
  },
  flyout: {
    fill: alpha(theme.palette.grey[700], 0.9),
    stroke: 'none'
  },
  flyoutPadding: {
    top: theme.spacing(1.5),
    bottom: theme.spacing(1.5),
    left: theme.spacing(1),
    right: theme.spacing(1)
  }
};

export const TooltipLabel = ({ selectedLabel, text, ...props }) => (
  <VictoryLabel
    {...props}
    text={text}
    lineHeight={1.44}
    style={text.map(line =>
      line.startsWith(selectedLabel)
        ? tooltipStyles.text.bold
        : tooltipStyles.text.base
    )}
  />
);

TooltipLabel.propTypes = {
  selectedLabel: PropTypes.string.isRequired,
  text: PropTypes.arrayOf(PropTypes.string)
};

export const createBOAChartTooltipContainer = ({
  labels,
  voronoiPadding,
  voronoiBlacklist,
  selectedLabel
}) => {
  const tooltipLabelComponent = <TooltipLabel selectedLabel={selectedLabel} />;

  const containerLabelComponent = (
    <VictoryTooltip
      style={tooltipStyles.text.bold}
      flyoutStyle={tooltipStyles.flyout}
      flyoutPadding={tooltipStyles.flyoutPadding}
      cornerRadius={TOOLTIP_CORNER_RADIUS}
      pointerLength={TOOLTIP_POINTER_LENGTH}
      centerOffset={TOOLTIP_CENTER_OFFSET}
      constrainToVisibleArea
      labelComponent={tooltipLabelComponent}
    />
  );

  return (
    <VictoryVoronoiContainer
      aria-labelledby="bench-detail-panel"
      mouseFollowTooltips
      labels={labels}
      labelComponent={containerLabelComponent}
      voronoiDimension="x"
      voronoiPadding={voronoiPadding}
      voronoiBlacklist={voronoiBlacklist}
    />
  );
};
